import { Controller } from "@hotwired/stimulus";

/**
 * Animate text
 * @see type-animation.twig
 * @example
 * ```
 * <ul data-controller="type-animation" data-type-animation-speed-value="3000">
 *   <li data-type-animation-target="item">Text 1</li>
 *   <li data-type-animation-target="item">Text 2</li>
 * </ul>
 * ```
 */
export class TypeAnimationController extends Controller {
  static targets = ["item"];
  static values = { speed: Number };

  activeItemIndex = 0;
  play = false;
  preferReducedMotion = false;

  connect() {
    console.info("Connect Type Animation controller");
    if (["UL", "OL"].includes(this.element.tagName)) {
      this.element.classList.add("js");
      this.initScroller();
    }
  }

  initScroller() {
    this.speedValue = this.speedValue || 3000;
    this.play = true;
    this.preferReducedMotion =
      window.matchMedia("(prefers-reduced-motion: reduce)")?.matches || false;

    if (!this.preferReducedMotion) {
      this.swap();
    } else {
      this.randomItem();
    }
  }

  swap() {
    if (this.play) {
      setTimeout(() => {
        this.nextItem();
        requestAnimationFrame(() => this.swap());
      }, this.speedValue);
    }
  }

  nextItem() {
    /** @type {HTMLLIElement[]} */
    const items = this.itemTargets;
    let newIndex;

    if (this.activeItemIndex < items.length - 1) {
      newIndex = this.activeItemIndex + 1;
    } else {
      newIndex = 0;
    }

    if (newIndex > this.activeItemIndex) {
      this.setItem(newIndex);
    } else if (newIndex === 0) {
      this.play = false;
    }
  }

  setItem(newIndex) {
    /** @type {HTMLLIElement[]} */
    const items = this.itemTargets;
    const currentItem = items[this.activeItemIndex];
    const nextItem = items[newIndex];

    nextItem.setAttribute("style", `transform: translateY(100%)`);
    currentItem.setAttribute(
      "style",
      `transform: translateY(-100%); opacity: 0`
    );
    nextItem.setAttribute("style", `transform: translateY(0%); opacity: 1`);
    this.activeItemIndex = newIndex;
  }

  randomItem() {
    const randomIndex = Math.floor(Math.random() * this.itemTargets.length - 1);
    this.setItem(randomIndex);
  }

  /**
   * Register controller as "dialog"
   * @param {import('stimulus').Application} application
   */
  static register(application) {
    application.register("type-animation", this);
  }
}
